
interface IEntityRelationshipSelectorBindings {
    relationshipCharTypeId: number;
    isAdvancedSearchViewDisabled: boolean;
}

export class EntityRelationshipSelectorComponentController implements IEntityRelationshipSelectorBindings {
    public relationshipCharTypeId: number;
    public isAdvancedSearchViewDisabled: boolean;
    constructor(
    ) {
        "ngInject";
     }
    public static $inject = [];
    public areTabsEnabled(): boolean {
        return !this.isAdvancedSearchViewDisabled && this.relationshipCharTypeId === 1;
    }
}

export class RLEntityRelationshipSelector implements angular.IComponentOptions {
    public bindings: any = {
        relationshipCharTypeId: "<",
        isAdvancedSearchViewDisabled: "<?",
    };
    public controller: any = EntityRelationshipSelectorComponentController;
    public controllerAs: string = "ersVm";
    public transclude: any = {
        "basic": "basic",
        "advanced": "advanced"
    };
    public template: string = require("./entity-relationship-selector.component.html");
}
